import RecordLogo from "@/components/brand/RecordLogo";

export default function HeroCover() {
  return (
    <div data-testid="hero-temporary-cover" className="relative isolate flex aspect-[4/5] w-full overflow-hidden rounded-[2rem] border border-gold/40 bg-[#3B2314] p-7 shadow-2xl md:aspect-[3/4] md:p-10">
      <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(230,0,126,0.95)_0%,rgba(230,0,126,0.95)_29%,transparent_29%,transparent_66%,rgba(201,162,39,0.8)_66%,rgba(201,162,39,0.8)_68%,transparent_68%)] opacity-90" aria-hidden="true" />
      <div className="absolute inset-0 bg-[repeating-linear-gradient(90deg,transparent_0,transparent_28px,rgba(246,235,221,0.06)_29px,transparent_30px)]" aria-hidden="true" />
      <div className="relative flex h-full w-full flex-col justify-between border border-gold/60 p-5 text-cream md:p-7">
        <div className="flex items-center justify-between gap-4">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold">TWSS</p>
          <p className="font-sans text-xs font-bold uppercase tracking-[0.18em] text-cream/80">Culture show</p>
        </div>
        <div className="relative flex flex-1 items-center justify-center py-8">
          <div className="absolute h-[72%] w-[72%] rounded-full border border-gold/50 bg-ink/80 shadow-[0_0_0_16px_rgba(59,35,20,0.45)]" aria-hidden="true" />
          <RecordLogo testid="hero-cover-record-logo" size={220} spin={false} className="relative w-[68%] max-w-[220px]" />
        </div>
        <div>
          <p className="font-display text-4xl font-black uppercase leading-[0.82] tracking-tight md:text-5xl">That&rsquo;s What <span className="italic text-neon">SHi</span> Said</p>
          <p className="mt-4 max-w-[13rem] font-editorial text-xl italic leading-tight text-gold">A temporary cover for the world we&rsquo;re building.</p>
        </div>
      </div>
    </div>
  );
}